<div class="translation-editable-modal">
  <div class="translation-editable-modal-header">
    <h4 class="translation-editable-modal-title">
      {{ 'DO_YOU_WANT_TO_UPDATE_TRANSLATE' | translate }}?
    </h4>

    <div class="modal-close" (click)="cancel()"></div>
  </div>

  <div class="translations">
    <form
      class="form"
      *ngFor="let fg of keysControls.controls"
      [formGroup]="fg"
    >
      <div class="field is-narrow">
        <label class="label">{{ 'TRANSLATION_KEY' | translate }}</label>
        <div>{{ fg.get('key').value }}</div>
      </div>

      <div class="field is-narrow">
        <label class="label">{{
          'TRANSLATION_DEFAULT_VALUE' | translate
        }}</label>
        <div>
          {{
            defaultTranslations[fg.get('key').value] ||
              data.translationDefaults[fg.get('key').value] ||
              fg.get('key').value
          }}
        </div>
      </div>

      <div class="field is-narrow">
        <label class="label">{{ 'TRANSLATION_VALUE' | translate }}</label>
        <div class="control">
          <input class="input" formControlName="value" type="text" />
        </div>
      </div>

      <div class="actions">
        <button
          [disabled]="isLoading || fg.invalid || fg.pristine"
          class="button is-info"
          (click)="updateTranslation(fg)"
        >
          {{ 'UPDATE' | translate }}
        </button>

        <button
          *ngIf="getCanRestoreToDefault(fg)"
          [disabled]="isLoading"
          class="button is-danger"
          (click)="resetToDefault(fg)"
        >
          {{ 'RESTORE_DEFAULT' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
